import CatalogLink from '@/components/Catalog/CatalogLink';
import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import PropTypes from 'prop-types';
import Button from '@/components/Buttons/Button';

const LoadMoreButton = React.memo(({ 
  onPress,
  href,
  isLoading = false,
  isLarge = false,
  style = {}
}) => {
  const { t } = useTranslation();

  return (
    <CatalogLink
      component={Button}
      href={href}
      text={t('common.loadMore')}
      variant="secondary"
      size={isLarge ? 'medium' : 'small'}
      isLoading={isLoading}
      onPress={onPress}
      style={style}
    />
  );
});

LoadMoreButton.propTypes = {
  onPress: PropTypes.func.isRequired,
  href: PropTypes.string,
  isLoading: PropTypes.bool,
  isLarge: PropTypes.bool,
  style: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
};

LoadMoreButton.displayName = 'LoadMoreButton';

export default LoadMoreButton; 